import { ColorPicker } from '@thoughtspot/radiant-react/widgets/colorpicker';
import { defaultColorPalette, defaultFullColorPalette, } from '@thoughtspot/radiant-react/widgets/colorpicker/color-constant';
import { FormControl } from '@thoughtspot/radiant-react/widgets/form-control';
import _ from 'lodash';
import React from 'react';
import styles from '../../styles/form-builder.module.scss';
export var SELECTOR_TYPE;
(function (SELECTOR_TYPE) {
    SELECTOR_TYPE["FONT"] = "FONT";
    SELECTOR_TYPE["COLOR"] = "COLOR";
})(SELECTOR_TYPE || (SELECTOR_TYPE = {}));
export const ColorPickerFormComponent = ({ elementKey, onChange, label, defaultValue, selectorType = SELECTOR_TYPE.COLOR, }) => {
    const onColorChange = (color) => {
        onChange(elementKey, color);
    };
    const defaultColors = _.flatten(_.concat(_.values(defaultColorPalette), defaultFullColorPalette.WHITE));
    return (React.createElement(FormControl, { label: label, className: `${styles.formComponentItem} ${styles.colorPickerContainer}`, "data-testid": `test-id-${elementKey}` },
        React.createElement(ColorPicker, { onChange: onColorChange, defaultValue: defaultValue, headerSelectorType: SELECTOR_TYPE[selectorType], colors: defaultColors, className: styles.colorPickerPopoverWidth, "data-testid": "colorpicker" })));
};
//# sourceMappingURL=color-picker-form.component.js.map